import { lazyLoad } from 'site-modules/shared/components/lazy-load/lazy-load';

export const SimpleInventoryViewAsync = lazyLoad({
  loader: () => import(/* webpackChunkName: "simple-inventory-view" */ './simple-inventory-view'),
  componentName: 'SimpleInventoryView',
});
